import { useState } from "react"
import {
	Box, Popover, Stack,
	FormControlLabel, Radio, RadioGroup, 
	Divider
} from "@mui/material"

import { SearchDetailResult } from "interface/search"
import { SearchWordField } from "components/controls/searchWordField"

import { SourceProject, SourceType, toSourceType } from "../../../types"
import { LvProjectList } from "./lvProjectList"
import { MrpProjectList } from "./mrpProjectList"

type AddProjectPopOverProps = {
	anchorEl: HTMLButtonElement
	search: SearchDetailResult
	defaultProject: SourceProject | null
	projectList: SourceProject[]
	onClose: () => void
	onAddProject: (project: SourceProject) => void
}
export const AddProjectPopOver = ({
	anchorEl,
	search,
	defaultProject,
	projectList,
	onClose,
	onAddProject
}: AddProjectPopOverProps) => {
	const [source, setSource] = useState<SourceType | null>(defaultProject?.source ?? null)
  const [searchWord, setSearchWord] = useState<string>(defaultProject?.productName ?? '')
	return (
		<Popover
			id="load-profile-popover"
			onClose={onClose}
			anchorOrigin={{
				vertical: 'bottom',
				horizontal: 'left',
			}}
			transformOrigin={{
				vertical: 'top',
				horizontal: 'left',
			}}
			anchorEl={anchorEl}
			open={Boolean(anchorEl)}
		>
			<Box maxHeight='50vh' width="40rem">
				<Stack direction="row" alignItems="center" marginRight={1}>
					<RadioGroup
						value={source}
						onChange={(e) => setSource(toSourceType(e.target.value))}
						sx={{ paddingX: 2, paddingY: 1 }}
					>
						<Stack direction='row' spacing={0}>
							<FormControlLabel value="mrp" control={<Radio />} label='MRP' />
							<FormControlLabel value="lv" control={<Radio />} label='Web講演会'/>
						</Stack>
					</RadioGroup>

					<Box flexGrow={1} />

					<SearchWordField
						id="search-word-search"
						searchWord={searchWord}
						onChangeSearchWord={setSearchWord}
					/>
				</Stack>

				{source === 'mrp' ? (
					<>
						<Divider/>
						<MrpProjectList
							searchWord={searchWord}
							search={search}
							exclusiveList={projectList.filter(p => p.source === 'mrp')}
							onAddProject={onAddProject}
							flexGrow={1}
							overflow='auto'
						/>
					</>
				) : source === 'lv' ? (
					<>
						<Divider/>
						<LvProjectList
							searchWord={searchWord}
							search={search}
							exclusiveList={projectList.filter(p => p.source === 'lv')}
							onAddProject={onAddProject}
							flexGrow={1}
							overflow='auto'
						/>
					</>
				) : <></>}
			</Box>
		</Popover>
	)
}
